const LOGO_URL = "https://customer-assets.emergentagent.com/job_tabletop-showcase/artifacts/4dj47y7o_file_000000006c38720abfd68ceed9ce979b~3.png";

export default function AboutPage() {
  return (
    <div className="min-h-screen py-12 md:py-24">
      {/* Hero Section */}
      <section className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center animate-fade-in-up">
          <img 
            src={LOGO_URL} 
            alt="Independent Boardgames Logo" 
            className="w-24 h-24 mx-auto mb-8 rounded-2xl shadow-lg"
          />
          <span className="inline-block px-4 py-1.5 bg-[#7C3AED]/10 text-[#7C3AED] text-xs font-sans font-bold rounded-full mb-6">
            About IBG
          </span>
          <h1 className="font-serif font-bold text-4xl md:text-5xl text-slate-900 mb-8 tracking-tight">
            Independent Board Games
          </h1>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-stone-200 shadow-sm">
          <p className="font-sans text-slate-700 text-lg leading-relaxed mb-6">
            Independent Board Games is a website to showcase self-published games, putting them in one place with access to the designers' websites where the games can be purchased.
          </p>
          
          <p className="font-sans text-slate-700 text-lg leading-relaxed mb-6">
            Independent Board Games isn't a business — we charge the creators a small fee of £10 for upkeep of the site. This site exists purely because I'm an enthusiast for board games and the industry, and I believe indie games make this a better hobby to be in.
          </p>

          <div className="bg-[#7C3AED]/10 rounded-2xl p-6 border border-[#7C3AED]/20 mt-8">
            <h2 className="font-serif font-bold text-xl text-slate-900 mb-3 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#7C3AED] rounded-full flex items-center justify-center text-white text-sm">✓</span>
              Our One Rule
            </h2>
            <p className="font-sans text-slate-700 leading-relaxed">
              For a game to be featured on our site, the designers and publishers must be the same people. We celebrate creators who design, produce, and sell their own games directly to the community.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="font-sans text-slate-600 mb-6">
            Interested in getting your game featured?
          </p>
          <a
            href="/submit-game"
            className="inline-flex items-center gap-2 bg-[#7C3AED] text-white px-8 py-4 rounded-full font-sans font-bold hover:bg-[#6D28D9] hover:scale-105 active:scale-95 transition-all shadow-lg shadow-[#7C3AED]/20"
            data-testid="cta-submit-game"
          >
            Get Your Game Listed
          </a>
        </div>
      </section>
    </div>
  );
}
